import * as t from "io-ts";
import nullable from "./nullable";
import { createCargoViewTypes } from "./cargo-view";
export const cargoEmissionsT = t.strict({
    emissionsExtraInKg: nullable(t.number),
    emissionsOperationalInKg: nullable(t.number),
    emissionsTotalInKg: nullable(t.number),
    distanceInKm: nullable(t.number),
    tkm: nullable(t.number),
});
export const createCargoEmissionsTypes = ({ decimal, dateTime, }) => {
    const { cargoViewT } = createCargoViewTypes({
        decimal,
        dateTime,
    });
    const cargoEmissionsResponseT = t.strict({
        clientId: nullable(t.string),
        cargoView: cargoViewT,
        cargoEmissions: cargoEmissionsT,
        consolidatedInvoicesRefs: t.array(t.string),
    });
    return { cargoEmissionsResponseT };
};
//# sourceMappingURL=cargo-emissions.js.map